module.exports = __webpack_public_path__ + "media/components/country-flag/static/mc-38420dd3153dda7bdfe6c4b25d545cd6.svg";